import { render, staticRenderFns } from "./ManterGrupoTrabalho.vue?vue&type=template&id=03f79f3a&scoped=true&"
import script from "./ManterGrupoTrabalho.vue?vue&type=script&lang=js&"
export * from "./ManterGrupoTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f79f3a",
  null
  
)

export default component.exports